var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dadosPf && _vm.dadosPj)?_c('div',[_c('header-pf',{attrs:{"dadosPj":_vm.dadosPj,"dadosPf":_vm.dadosPf}}),_c('alertas',{staticClass:"mt-4 mb-4",attrs:{"alertas":_vm.dadosPf.despesasComVencimentoProximo,"tipo":"Despesa"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }